module.exports = "../study/imgs/maps/Nagano/S8/Agriculture/RiceQ/Nagano_RiceQ_MRI_RCP26_Mid.png";